module.exports = __webpack_public_path__ + "img/giverise-logo-white.ec6fc58b.svg";